import { render, staticRenderFns } from "./GridProgramList.vue?vue&type=template&id=fb187164&scoped=true&"
import script from "./GridProgramList.vue?vue&type=script&lang=js&"
export * from "./GridProgramList.vue?vue&type=script&lang=js&"
import style0 from "./GridProgramList.vue?vue&type=style&index=0&id=fb187164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb187164",
  null
  
)

export default component.exports